import React, { useState, useEffect } from 'react'
import { createNonceStr, md5, getLocationSearch } from '@/utils/utils'
import request from '@/utils/request'
import './index.scss'
// import Header from '@/components/header'
// import {connect} from 'react-redux'
import { Bscroll } from '@/components/bscroll'
import { invActRewardApi } from '@/api'
import { useTranslation } from '@/i18n'

const InviteInfo = (props) => {
  const t = useTranslation();
  //获取token
  let getToken = getLocationSearch().token
  // 邀请人数 和 奖励
  let { p, money } = props.match.params
  //邀请列表
  const [inviteList, setInviteList] = useState([]);
  //获取当前司机奖励接口
  useEffect(() => {
    const pageTitle = t('inviteInfo.pageTitle');
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    if (isAndroid) {
      // window.handleGoBack();//这里的.android是安卓那边定义的类,可以随便定义,但这里必须要跟安卓那边统一
      if(typeof window?.savePicture?.setTitle === 'function'){
        window?.savePicture?.setTitle(pageTitle)
      }
    }
    window.document.title = pageTitle
    //带Token签名
    let appKey = 'app_h5';
    let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let token = getToken
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    // console.log(appKey,timestamp,random,sign,token)
    request.get(invActRewardApi, {
      token: token,
    }, {
      appKey: appKey,
      timestamp: timestamp,
      random: random,
      token: token,
      sign: sign
    })
      .then((data) => {
        //等待接口确认
        if (data.data.data) {
          setInviteList(data.data.data)
        }
      })
    return () => {
    }
  }, [getToken]) // 只依赖getToken，避免t函数导致死循环
  return (
    <div className="inviteInfo__box">
      {/* <Header tit="邀请记录" /> */}
      <div className='invite-info-content'>
        <div>
          <article>
            <span>
              <em>{p}</em>{t('invite.personUnit')}
            </span>
            <span>{t('invite.inviteCount')}</span>
          </article>
        </div>
        <div>
          <article>
            <span className='num'>
              <em>{money / 100}</em>{t('invite.yuanUnit')}
            </span>
            <span>{t('invite.receivedReward')}</span>
          </article>

        </div>
      </div>

      {/* <div className="invite-data__tit">
        <span>
          邀请人数
          <em>{p}</em><i>人</i>
        </span>
        <span>
          获得奖励
          <em>{money/100}</em><i>元</i>
        </span>
      </div> */}
      <p>
        <i/>
        <span>{t('inviteInfo.recordAndReward')}</span>
      </p>
      <div className="invite-data__list">
        <Bscroll scrollX={false} scrollY={true} bounce={{ bottom: false }}>
          <div>
            {
              inviteList.map((item, index) => (
                <div className="invite-record" key={index}>
                  <p>
                    <span>{item.inviteePhone}</span>
                    {
                      item.inviterRewardAmount === 0 || !item.inviterRewardAmount ?
                        <span style={{ color: '#888' }}>{(item.inviterNoRewardReason === '' ? t('inviteInfo.noReward') : item.inviterNoRewardReason)}</span> :
                        <span style={{ color: "#F3976E" }}>+{item.inviterRewardAmount / 100}{t('invite.yuanUnit')}</span>
                    }

                  </p>
                  <p>{item.inviteeTime}</p>
                </div>
              ))
            }

          </div>
        </Bscroll>
      </div>
    </div>
  )
}
export default InviteInfo
